import { createReducer } from '@reduxjs/toolkit'

import { agentLoggedIn, agentLoggedOut, loggedInClubOne, updateAgentIdFieldValue } from '../actions/actions'

export const initialState = { valid: true, agentName: '', agentId: '', agentIdFieldValue: '' }

const agent = createReducer(initialState, {
  [agentLoggedIn]: (state, { payload }) => {
    state.valid = payload.valid
    state.agentName = [payload.firstName, payload.lastName].join(' ').trim()
    state.agentId = payload.agentId
  },
  [agentLoggedOut]: () => initialState,
  [updateAgentIdFieldValue]: (state, { payload }) => {
    state.agentIdFieldValue = payload
  },
  [loggedInClubOne]: () => initialState
})

export default agent
